module.exports = __webpack_public_path__ + "img/zhu_xc7.b06f1e07.jpg";